import React__default from 'react';
import classnames from 'classnames';
import { Text } from '@grandvisionhq/elements';
import { ProductStockIndicator } from '../../StockIndicator/ProductStockIndicator.js';

const FacetPicker = ({ onPick , itemComponent , activeFacetTerm , items , title , className , enableStockIndicator , showFacetName , productType ,  })=>{
    const ItemComponent = itemComponent;
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('facet-picker', className)
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "facet-picker__header"
    }, /*#__PURE__*/ React__default.createElement(Text, {
        variant: "body-head"
    }, title), enableStockIndicator && /*#__PURE__*/ React__default.createElement(ProductStockIndicator, null)), showFacetName && /*#__PURE__*/ React__default.createElement("div", {
        className: "facet-picker__info"
    }, activeFacetTerm), /*#__PURE__*/ React__default.createElement("div", {
        className: "facet-picker__facets"
    }, /*#__PURE__*/ React__default.createElement("ul", {
        className: classnames(`facet-picker__tiles`, {
            'facet-picker__tiles--single': items.length == 1,
            [`${className}__tiles`]: className
        }),
        "aria-label": title
    }, items.map((item, index)=>/*#__PURE__*/ React__default.createElement("li", {
            key: index,
            className: classnames(`facet-picker__item`, {
                [`${className}__item`]: className
            })
        }, /*#__PURE__*/ React__default.createElement(ItemComponent, {
            isActive: item.facetTerm === activeFacetTerm,
            item: item,
            onPick: onPick,
            productType: productType
        }))
    ))));
};

export { FacetPicker };
//# sourceMappingURL=FacetPicker.js.map
